export const PLATFORMS_SET = 'platformsSet';
export const STATUS_SET = 'statusSet';
export const LIBRARY_SET = 'librarySet';